<template>

</template>

<script>
  export default {
    name: "OrderManagement"
  }
</script>

<style scoped>

</style>
